// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f357db3e","239":"197dc31d","455":"19157ac3"}[chunkId] + ".chunk.js";
};